<template>
  <main class="main-container">
    <router-view />
  </main>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>
  .main-container {
    flex: 1;
    width: 100%;
    max-width: 1280px;
    padding: 36px 24px 24px;
    margin: auto;
  }

  @media screen and (max-width: 640px) {
    .main-container {
      padding: 24px 16px 16px;
    }
  }
</style>
